import React from 'react';
import { useParams } from 'react-router-dom';
import VehiclesDevicesList from    './components/vehiclesDevicesList/VehiclesDevicesList';
import VehiclesDeviceDetails from './components/vehiclesDevicesDetails/VehiclesDeviceDetails';
import styles from './VehiclesDevicesTab.module.scss';

const VehiclesDevicesTab = () => {    
    const { type } = useParams<{ type: string, itemId: string }>();
    
    return <div className={styles.container}>
    {
        (type === 'list' ? <VehiclesDevicesList /> : <VehiclesDeviceDetails />)
    }
    </div>;
}

export default VehiclesDevicesTab;
